  {
    "Basic": [
      {
        "menu_label": "Participant Interest",
        "menu_id": "participant_leads",
        "landing_component": "participantLeadsList",
        "display": "y"
      },
      {
        "menu_label": "Provider Interests",
        "menu_id": "provider_leads",
        "landing_component": "providerLeadsList",
        "display": "y"
      }
    ]
  }